"use strict";
/**
 * Copyright © 2019 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentBand = void 0;
const React = __importStar(require("react"));
const material_1 = require("@mui/material");
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const SPACING = 16;
const useStyles = makeStyles_1.default((theme) => ({
    bandStyle: {
        zIndex: theme.zIndex.drawer + 2,
        backgroundColor: '#39ff14',
        position: 'fixed',
        marginTop: theme.spacing(-1),
        left: theme.spacing(SPACING),
        width: 'auto',
        top: 0,
        height: 'auto',
    },
}));
exports.EnvironmentBand = ({ environment, version }) => {
    const classes = useStyles({});
    if (environment.toLowerCase() === 'prd') {
        return null;
    }
    return (React.createElement("div", { className: classes.bandStyle },
        React.createElement(material_1.Typography, { style: { padding: 5 }, variant: "body1", color: "textSecondary", align: "center" },
            environment,
            " version@",
            version)));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRW52aXJvbm1lbnRCYW5kLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRW52aXJvbm1lbnRCYW5kLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBRUgsNkNBQStCO0FBQy9CLDRDQUFrRDtBQUNsRCx3RUFBZ0Q7QUFPaEQsTUFBTSxPQUFPLEdBQUcsRUFBRSxDQUFDO0FBQ25CLE1BQU0sU0FBUyxHQUFHLG9CQUFVLENBQUMsQ0FBQyxLQUFZLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDOUMsU0FBUyxFQUFFO1FBQ1QsTUFBTSxFQUFFLEtBQUssQ0FBQyxNQUFNLENBQUMsTUFBTSxHQUFHLENBQUM7UUFDL0IsZUFBZSxFQUFFLFNBQVM7UUFDMUIsUUFBUSxFQUFFLE9BQU87UUFDakIsU0FBUyxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDNUIsSUFBSSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDO1FBQzVCLEtBQUssRUFBRSxNQUFNO1FBQ2IsR0FBRyxFQUFFLENBQUM7UUFDTixNQUFNLEVBQUUsTUFBTTtLQUNmO0NBQ0YsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLGVBQWUsR0FBRyxDQUFDLEVBQUUsV0FBVyxFQUFFLE9BQU8sRUFBeUIsRUFBRSxFQUFFO0lBQ2pGLE1BQU0sT0FBTyxHQUFHLFNBQVMsQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUU5QixJQUFJLFdBQVcsQ0FBQyxXQUFXLEVBQUUsS0FBSyxLQUFLLEVBQUU7UUFDdkMsT0FBTyxJQUFJLENBQUM7S0FDYjtJQUNELE9BQU8sQ0FDTCw2QkFBSyxTQUFTLEVBQUUsT0FBTyxDQUFDLFNBQVM7UUFDL0Isb0JBQUMscUJBQVUsSUFBQyxLQUFLLEVBQUUsRUFBRSxPQUFPLEVBQUUsQ0FBQyxFQUFFLEVBQUUsT0FBTyxFQUFDLE9BQU8sRUFBQyxLQUFLLEVBQUMsZUFBZSxFQUFDLEtBQUssRUFBQyxRQUFRO1lBQ3BGLFdBQVc7O1lBQVcsT0FBTyxDQUNuQixDQUNULENBQ1AsQ0FBQztBQUNKLENBQUMsQ0FBQyJ9